import React from 'react'

import { FormComponent } from './components/Form'
import { Logotypes } from './components/Logotypes'
import './PasswordRecovery.scss'

export const PasswordRecovery = () => {
    return (
        <div className="password-recovery d-flex flex-column flex-fill">
            <Logotypes />
            <FormComponent />
        </div>
    )
}
